import type { PETComposition, SpecificationListItem } from 'api';
import { Stack } from 'ui';

import { buildPETAiSampleCompositionItems } from '../../utils/buildPETCompositionItems/buildPETAiSampleCompositionItems';
import { MaterialBreakdownItem } from '../MaterialBreakdownItem/MaterialBreakdownItem';

export const AiPetSampleBreakdown = ({
  composition,
  totalWeight,
  instructions,
}: {
  composition: PETComposition;
  totalWeight: number;
  instructions?: SpecificationListItem[];
}) => {
  const { targetPetSection, nonTargetSection } = buildPETAiSampleCompositionItems(
    composition,
    totalWeight,
    instructions
  );

  return (
    <Stack
      data-testid="ai-pet-sample-breakdown"
      sx={{
        gap: 2,
      }}
    >
      <div>
        {targetPetSection.items.map((item, index) => (
          <MaterialBreakdownItem
            key={`${item.label}-${index}`}
            label={item.label}
            value={item.value}
            secondaryValue={item.secondaryValue}
            highlight={item.highlight}
            variant={item.variant}
            dataTestId={item.dataTestId}
          />
        ))}
      </div>
      <div>
        {nonTargetSection.items.map((item, index) => (
          <MaterialBreakdownItem
            key={`${item.label}-${index}`}
            label={item.label}
            value={item.value}
            secondaryValue={item.secondaryValue}
            highlight={item.highlight}
            variant={item.variant}
            dataTestId={item.dataTestId}
          />
        ))}
      </div>
    </Stack>
  );
};
